/* @flow */

import Loading from './Loading';

export default
    (func: Function) =>
    (...args: any) =>
    Promise.resolve()
    .then(() => Loading.show())
    .then(() => func(...args))
    .catch((error) => {
        Loading.hide();
        return Promise.reject(error);
    })
    .then((result) => {
        Loading.hide();
        return result;
    });



// WEBPACK FOOTER //
// ./app/utils/apply-loading.js